import { ApiConstant } from "@/const";
import { SailorIdApi } from "./config/api.config";
import { ResponseDataList, ResponseShipType } from "@/types/service";

const formatResponseData = (response?: ResponseDataList<ResponseShipType>) => {
  return {
    ...response,
    data: response?.data?.map((item: ResponseShipType) => {
      return {
        ...item,
        createdAt: (item?.created && new Date(item?.created)) || undefined,
      };
    }),
  };
};

export const getShipList = async (payload: any) => {
  const response = await SailorIdApi.toCamel().get<any>(ApiConstant.GET_SHIP_LIST, payload);
  if (response.ok && response.data) return formatResponseData(response?.data?.data);
  throw response;
};
